<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
      :show="false"
      :showUploadFile="true"
      uploadFileText="上传"
      :showDownloadPower="true"
      showDownloadPowerType="warning"
      downloadPowerText="下载"
      @down="down"
      ref="commonTopForm"
      :rules="formRules"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="会员级别" prop="memLevel">
        <el-select v-model="formModel.memLevel">
          <el-option
            v-for="item in levelList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="数量"
        :prop="formModel.startMyCount ? 'endMyCount' : 'startMyCount'"
      >
        <el-input
          v-model.number="formModel.startMyCount"
          maxlength="20"
          placeholder="起始"
          style="width: 150px"
        ></el-input>
        <span>~</span>
        <el-input
          v-model.number="formModel.endMyCount"
          maxlength="20"
          placeholder="结束"
          style="width: 150px"
        ></el-input>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
          v-model="formModel.updateTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      :isShow="false"
    >
      <el-table-column
        type="index"
        min-width="80"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="levelName"
        label="等级"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="myCount"
        label="数量-1"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="myCount2"
        label="数量-2"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";

import MarketService from "service/MarketService";
import StatisticsService from "service/StatisticsService";
import MemberLevelService from "service/MemberLevelService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "dandeliondotsort",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
  },
  data() {
    var validateStart = (rule, value, callback) => {
      if (this.formModel.endMyCount) {
        callback(new Error("无效的区间范围"));
      }
      callback();
    };
    var validateEnd = (rule, value, callback) => {
      if (this.formModel.startMyCount) {
        if (Number(this.formModel.startMyCount) <= Number(value)) {
          callback();
        } else {
          callback(new Error("无效的区间范围"));
        }
      } else {
        callback();
      }
    };
    return {
      levelList: [],
      all: [
        {
          id: "",
          levelName: "全部",
        },
      ],
      formModel: {
        tatSimpleId: "",
        updateTime: "",
        startMyCount: "",
        endMyCount: "",
        memLevel: "",
      },
      tableData: [],
      formDialogTitle: "",
      dialogModel: {},
      dialogRules: {},
      params: {},
      page: {},
      adjustId: "",
      submitService: MarketService.dandeliondotsortList,
      isPage: false,
      formRules: {
        startMyCount: [
          { required: false, message: "请输入区间最小值" },
          { validator: validateStart },
        ],
        endMyCount: [
          { required: false, message: "请输入区间最大值" },
          { validator: validateEnd },
        ],
      },
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
    this.formModel = {
      memLevel: "",
      updateTime: "",
    };
  },
  computed: {
    submitData() {
      if (
        this.formModel.updateTime == null ||
        this.formModel.updateTime == ""
      ) {
        this.formModel.updateTime = [];
      }
      const params = {
        // userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        startMyCount: this.formModel.startMyCount,
        endMyCount: this.formModel.endMyCount,
        memLevel: this.formModel.memLevel,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.updateTime.length) {
        params.beginDate = this.formModel.updateTime[0];
        params.endDate = this.formModel.updateTime[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    "formModel.tatSimpleId"(val, oldVal) {
      if (val) {
        this.formModel.memLevel = "";
        this.getLevelList(val);
      } else {
        this.levelList = [];
        this.formModel.memLevel = "";
      }
    },
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getLevelList(val) {
      this.doLoad(
        MemberLevelService.select,
        {
          tatSimpleId: val,
        },
        (res) => {
          this.levelList = [...this.all, ...res.contents.memLevelManageList];
        },
        "信息获取失败"
      );
    },
    getList() {
      this.doLoad(
        MarketService.dandeliondotsortList,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result;
            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    down() {
      if (!this.formModel.tatSimpleId) {
        this.showWarming("请选择机构");
        return;
      }
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "countListExport",
            "8880",
            "/tatPublicPlatoonPeopleSuper/"
          )
        : "";
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
  },
};
</script>

<style scoped>
.el-form-item.is-error >>> .el-input__inner {
  border-color: #e6a23c;
}
.el-form-item >>> .el-form-item__error {
  color: #e6a23c;
}
</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/DandelionDotSort.vue